import type {AnalyticsCfgClusterSubMenuParam, ClusterCfgType} from "../../types-analytics";
import {SimpleSelect} from "./SimpleSelect";
import Checkbox from "../Checkbox";
import './SelectSubMenuOptions.scss';


type SelectSubMenuProps = {
    cluster_name: string; // ex. "Najbliższy punkt"
    name_db: string; // ex. "c_distance" | "c_women_registered_count_working_age
    cluster_cfg: ClusterCfgType; // ex. { category: "dyskontu" }
    cluster_params: { [key: string]: AnalyticsCfgClusterSubMenuParam };
}

type SelectSubMenuCallbacks = {
    onChange: (cluster_cfg: ClusterCfgType) => void;
}

type ClickableOption = {
    cluster_name: string;
    type: 'select' | 'checkbox';
    element: SimpleSelect | null;
    onChange: (value: string) => void;
}

export class SelectSubMenuOptions {
    
    private root: HTMLDivElement;
    private props: SelectSubMenuProps;
    private callbacks: SelectSubMenuCallbacks;
    private clickableOptions: ClickableOption[] = [];
    private output_cluster_cfg: { [key: string]: string|boolean } = {};
    
    constructor(root: HTMLDivElement, props: SelectSubMenuProps, callbacks: SelectSubMenuCallbacks) {
        this.root = root;
        this.props = props;
        this.callbacks = callbacks;
        this.output_cluster_cfg = Object.assign({}, this.props.cluster_cfg);
        this.init();
    }
    
    private updateCfg(key: string, value: string|boolean) {
        this.output_cluster_cfg[key] = value;
        this.callbacks.onChange(this.output_cluster_cfg);
    }
    
    public getOutputCfg() {
        return this.output_cluster_cfg;
    }
    
    private init() {
        this.root.innerHTML = this.getHTML();
        
        let root: HTMLDivElement | null;
        
        Object.keys(this.props.cluster_params).forEach((key: string) => {
            let param: AnalyticsCfgClusterSubMenuParam = this.props.cluster_params[key];
            console.debug('SelectSubMenuOptions, param', param);
            switch (param.type) {
                case 'select':
                    root = document.createElement('div') as HTMLDivElement;
                    root.innerHTML = `
                    <div class="select-container">
                        ${(param.label !=='' ? `<div class="label">${param.label}</div>` : '')}
                        <div class="js-select"></div>
                    </div>
                    `;
                    this.root.querySelector('.select-submenu-options')?.appendChild(root);
                    let availableEntries = param.values.map((value: string) => {
                        return { id: value, name: value };
                    });
                    let selectedIds = [String(this.props.cluster_cfg[key])] as string[];
                    if (availableEntries.length > 1) {
                        new SimpleSelect(
                            root.querySelector('.js-select') as HTMLDivElement,
                            {
                                multiple: false,
                                allAvailableEntries: availableEntries,
                                selectedIds: selectedIds
                            },
                            {
                                onChangeWhileOpen: (selectedIds: string[]) => {
                                    console.log('onChangeWhileOpen', selectedIds);
                                    this.updateCfg(key, selectedIds[0]);
                                    this.callbacks.onChange(this.getOutputCfg());
                                    return true;
                                }
                            })
                    } else {
                        root.querySelector('.js-select')?.remove();
                        root.querySelector('.select-container')?.appendChild(document.createTextNode(availableEntries[0].name));
                    }
                    break;
                case 'checkbox':
                    console.debug('SelectSubMenuOptions, checkbox', this.props.cluster_name, key, this.props.cluster_cfg[key]);
                    root = Checkbox(
                        {
                            label: param.label,
                            checked: this.props.name_db.indexOf(key) > -1,
                            disabled: false,
                            mode: 'white-checkbox'
                        }, {
                            onChange: (checked: boolean) => {
                                console.log('onChange', checked);
                                this.updateCfg(key, checked);
                                this.callbacks.onChange(this.getOutputCfg());
                            }
                        }
                    ).element;
                    this.root.querySelector('.select-submenu-options')?.appendChild(root);
                    break;
                default:
                    throw new Error('Unknown param type: ' + param.type);
            }
        });
    }
    
    private getHTML() {
        return `
        <div style="display: flex; flex-direction: column; color: white;">
            <div class="select-submenu-options">
            </div>
        </div>
        `;
    }
    
}


/*
$_CFG.fld.c_dist_cosmetic
{
  "name_db": "c_dist_cosmetic",
  "name_orig": "dist_cosmetic",
  "label": "Odległość do drogerii",
  "fk": 0,
  "filter_str": "z odległością do drogerii %< %vą%%cmp%%>",
  "desc": "Odległość do drogerii",
  "type_gm": "int",
  "filter": 1,
  "attr_gm": [],
  "cluster": "Najbliższy punkt",
  "cluster_cfg": {
    "category": "drogerii"
  },
  "unit": "m",
  "colorable": 1,
  "min": "0",
  "max": "45028"
}

$_CFG.clusters['Najbliższy punkt']
{
  "label": "Najbliższy punkt",
  "params": {
    "category": {
      "label": "Odległość do",
      "type": "select",
      "order": [
        0,
        0
      ],
      "values": [
        "drogerii",
        "dyskontu",
        "hipermarketu",
        "sklepu spożywczego sieciowego",
        "supermarketu"
      ]
    }
  }
}
 */